// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"d7172a93","203":"3808c6ed","299":"042d5703","321":"7e16eab3","388":"166d1d28","435":"55d20afc","520":"34c8963c","530":"57f80fbf","654":"0b91330b","779":"55d20afc"}[chunkId] + ".chunk.css";
};